<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height class="bg">
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
              <!-- <span style="color:white;">{{url_redirect}}</span> -->
            <v-card class="elevation-12 mx-auto" style="border-width: 2px; border-radius: 15px; width: auto; background-color: rgba(4, 70, 102, 0.85);" v-if="url_redirect" >
              <v-card-title style="justify-content: center; display: flex;">
                <div style="margin-top: 2em;" align="center">
                  <font color="white" style="font-weight: bold; font-size: 2.3em;">ONECHAT OFFICIAL</font>
                </div>
              </v-card-title>
              <v-card-text>
                <v-flex v-if="type=='first'">
                  <v-layout column align-center>
                    <h4 style="color:white; font-weight: bold;" class="centerDiv CSChatThai"> ยินดีต้อนรับเข้าสู่ OneChat Official </h4>
                     <p style="color:white; font-weight: bold;" >กรุณาเลือกรูปแบบการลงชื่อเข้าใช้งาน</p>
                      <v-btn class="btnloginwebOneid  pl-5 pr-5" @click="loginRedirect()"  style="border-radius: 50px; height: 36px !important;  border-width: 2px; overflow: hidden;">
                        เข้าสู่ระบบด้วย ONEID
                      </v-btn>
                      <span class="textor"> หรีอ </span>
                      <v-btn class="btnloginwebOneid_white pl-5 pr-5" @click="type='phone'" style="margin-bottom:28px;">
                        เข้าสู่ระบบด้วยเบอร์โทรศัพท์
                      </v-btn>
                  </v-layout>
                </v-flex>
                <v-flex v-else-if="type=='phone'">
                  <v-layout column align-center>
                    <!-- <v-text-field solo label="เบอร์โทรศัพท์" v-model="phone" class="CSChatThai" style="text-align:center; color: white !important; border-radius:50px !important;" @keyup.enter="otp()" mask="###-###-####" prepend-inner-icon="phone"></v-text-field> -->
                    <v-text-field
                      style="width:80%; border-radius: 50px;"
                      dense
                      v-model="phone"
                      mask="###-###-####"
                      prepend-inner-icon="phone"
                      name="login"
                      label="เบอร์โทรศัพท์"
                      color="#607d8b"
                      solo
                    >
                    </v-text-field>
                    <v-layout>
                      <v-flex xs6 sm6 lg6 xl6>
                        <v-btn class="btnloginBackStep pl-5 pr-5" style="margin-bottom:28px;" @click="backStep()">
                          ย้อนกลับ
                        </v-btn>
                      </v-flex>
                      <v-flex xs6 sm6 lg6 xl6>
                        <v-btn class="btnloginwebOneid pl-5 pr-5" @click="otp()" :loading="isLoading"  :disabled="phone === ''"  style="margin-bottom:28px;">
                          ขอ OTP
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-flex>
                <v-flex v-else-if="type=='otp'">
                  <v-layout column align-center>
                    <!-- <v-text-field solo label="เบอร์โทรศัพท์" v-model="phone" class="CSChatThai" style="text-align:center; color: white !important; border-radius:50px !important;" @keyup.enter="otp()" mask="###-###-####" prepend-inner-icon="phone"></v-text-field> -->
                    <p style="color: white;">เบอร์โทร: {{phone}}</p>
                    <p style="color: white;">Refcode: {{Refcode}}</p>
                    <v-flex xs12 sm12 md12>
                      <v-layout wrap>
                        <v-flex xs8 sm8 md8 lg8>
                          <v-text-field solo label="otp" v-model="otpCode" maxlength="6"  class="CSChatThai" style="text-align:center; color: white !important; border-radius:50px !important;" @keyup.enter="loginWithotp()"></v-text-field>
                        </v-flex>
                        <v-flex  xs4 sm4 md4 lg4>
                          <v-btn depressed class="btnloginwebOneid_white"  :disabled="counting" @click="otp()">
                            <countdown v-if="counting" :time="60000" @end="handleCountdownEnd">
                              <template slot-scope="props">{{ props.totalSeconds }} วินาที </template>
                            </countdown>
                            <span v-if="!counting">ส่ง OTP </span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-layout>
                      <v-flex xs6 sm6 lg6 xl6>
                        <v-btn class="btnloginBackStep pl-5 pr-5" style="margin-bottom:28px;" @click="backStep()">
                          ย้อนกลับ
                        </v-btn>
                      </v-flex>
                      <v-flex xs6 sm6 lg6 xl6>
                        <v-btn class="btnloginwebOneid" @click="loginWithotp()" :loading="isLoading" :disabled="otpCode.length != 6" style="margin-bottom: 30px;">เข้าสู่ระบบ</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-flex>

              </v-card-text>
            </v-card>

            <v-card class="elevation-12 mx-auto" style="border-width: 2px; border-radius: 15px; width: auto; background-color: rgba(4, 70, 102, 0.85);" v-else>
              <v-card-title style="justify-content: center; display: flex;">
                <div style="margin-top: 2em;" align="center">
                  <font color="white" style="font-weight: bold; font-size: 2.3em;">ONECHAT OFFICIAL</font>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form ref="form" v-model="valid" lazy-validation style="margin-top: 2em; margin-left: auto; margin-right: auto; width: 85%;">
                  <v-text-field
                    :rules="requiredRules"
                    v-model="username"
                    prepend-inner-icon="person"
                    name="login"
                    label="ชื่อผู้ใช้งาน"
                    color="#607d8b"
                    type="text"
                    single-line
                    solo
                  >
                  </v-text-field>

                  <v-text-field
                    :rules="requiredRules"
                    v-model="password"
                    prepend-inner-icon="lock"
                    @keyup.enter="login()"
                    id="password"
                    name="password"
                    label="รหัสผ่าน"
                    color="#607d8b"
                    :type="show_password ? 'text' : 'password'"
                    :append-icon="show_password ? 'visibility' : 'visibility_off'"
                    @click:append="show_password = !show_password"
                    single-line
                    solo
                  >
                  </v-text-field>
                  <v-layout
                    align-center
                    justify-end
                  >
                    <a href="https://one.th/type_forgot_password" target="_blank"><font size="3" color="white">ลืมรหัสผ่าน ?</font></a>
                  </v-layout>
                  <v-layout
                    align-center
                    justify-center
                    style="margin-top:2em; width: 100%;"
                  >
                    <v-btn
                      class="btnloginwebOneid_white pl-5 pr-5"
                      dark
                      color="#103f5a"
                      v-on:click="login()"
                      :loading="isLoading"
                      style="border-radius: 50px; width: 100%; height: 2.5em; font-size: 1.5em; border-width: 2px; overflow: hidden;"
                    >
                      เข้าสู่ระบบ
                    </v-btn>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { Encode } from '@/services'
import Vue from 'vue'
import VueCountdown from '@chenfengyuan/vue-countdown'

Vue.component(VueCountdown.name, VueCountdown)
var _ = require('lodash')
export default {
  data: () => ({
    show_password: false,
    valid: true,
    drawer: null,
    username: '',
    password: '',
    isLoading: false,
    requiredRules: [
      v => !!v || 'กรุณากรอกข้อมูลให้ครบถ้วน'
    ],
    status_login: '',
    //
    url_redirect: process.env.VUE_APP_API_AUTHENONEID,
    type: 'first',
    progress: false,
    phone: '',
    otpCode: '',
    Refcode: '',
    mobile_ref_id: '',
    counting: false
    // url_redirect: 'dddd',
  }),
  created () {
    // if (localStorage.getItem('name')) {
    //   this.$router.push('/profile')
    // }
  },
  mounted () {
    this.status_login = localStorage.getItem('status_login')
    if (this.status_login === 'T') {
      this.$router.push('/homepage')
    }
  },
  methods: {
    backStep () {
      this.type = 'first'
      this.phone = ''
    },
    loginRedirect () {
      this.isLoading = true
      // console.log(this.url_redirect)
      window.open(this.url_redirect, '_parent')
    },
    otp () {
      this.isLoading = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/otp_login_and_regis', {
        phone: this.phone,
        type: 'login'
      }).then((response) => {
        // console.log(response)
        if (response.data['status'] === 'success') {
          if (response.data.type_otp == 'login') {
            this.isLoading = false
            this.Refcode = response.data.refcode
            this.mobile_ref_id = response.data.mobile_ref_id
            this.type_otp = response.data.type_otp
            this.counting = true
            this.type = 'otp'
          } else {
            this.isLoading = false
            this.phone = ''
            this.$swal(
              'ขออภัย!',
              'หมายเลขโทรศัพท์นี้ยังไม่ได้รับการลงทะเบียน กรุณาลงทะเบียนหรือกรอกหมายเลขโทรศัพท์อื่น',
              'error'
            )
          }
        } else if (response.data['message'] === 'No JSON object could be decoded') {
          this.isLoading = false
          this.$swal(
            'ขออภัย!',
            'ระบบขัดข้อง กรุณาลองใหม่ในภายหลัง.',
            'error'
          )
        } else if (response.data['message'] === 'too many requests.') {
          this.isLoading = false
          this.$swal(
            'ขออภัย!',
            'หมายเลขโทรศัพท์นี้ร้องขอ otp บ่อยเกินไป กรุณารอซักครู่แล้วเริ่มทำรายการใหม่',
            'error'
          )
        } else {
          this.isLoading = false
          this.$swal(
            response.data['status'],
            response.data['message'],
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.status = 'fail'
        this.progress = false
        this.type = 'first'
        this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    },
    handleCountdownEnd () {
      this.OTP = ''
      this.counting = false
    },
    login () {
      // console.log(this.password)
      if (!this.$refs.form.validate()) {
        return
      }
      var textSource = { 'username': this.username, 'password': this.password }
      var source = Encode.encode(textSource)
      this.isLoading = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/loginuserwithbusiness', { source: source }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          localStorage.setItem('status_login', 'T')
          localStorage.setItem('profilepicture', response.data['account']['profile']['profilepicture'])
          localStorage.setItem('tokenservice', Encode.encodeToken(response.data['account']['profile']['tokenservice']))
          localStorage.setItem('tokenuser', Encode.encodeToken(response.data['account']['profile']['tokenuser']))
          localStorage.setItem('name', response.data['account']['profile']['name'])
          localStorage.setItem('phone', response.data['account']['profile']['phone'])
          localStorage.setItem('email', response.data['account']['profile']['email'])
          localStorage.setItem('status', response.data['account']['profile']['status'])
          // location.pathname = '/profile'
          // this.$router.push('/homepage')
          this.getlistbot(response.data['account']['profile']['tokenuser'])
        } else {
          this.$swal({ title: 'กรุณาตรวจสอบ Username / Password ของท่านให้ถูกต้อง', type: 'warning' })
          localStorage.setItem('status_login', 'F')
        }
        this.isLoading = false
      }).catch(error => {
        this.$swal({ title: 'ระบบ login ขัดข้อง', text: 'กรุณาลองใหม่อีกครั้ง', type: 'error' })
        this.isLoading = false
        console.log(error)
      })
    },
    getlistbot (tokenuser) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistbot', { tokenuser: tokenuser }).then((response) => {
        if (response.data.message === 'success') {
          var listbot = response.data.listbot
          if (listbot.length !== 0) {
            listbot = _.orderBy(listbot, ['nickname'], ['asc'])
            localStorage.setItem('tokenbot', listbot[0].tokenuser)
            // this.$router.push('/account/' + listbot[0].tokenuser)
            if (localStorage.getItem('path_redirect') !== null && localStorage.getItem('path_redirect') !== undefined) {
              this.$router.push(localStorage.getItem('path_redirect'))
              localStorage.removeItem('path_redirect')
            } else {
              this.$router.push('/account/' + listbot[0].tokenuser)
            }
          } else {
            this.$router.push('/homepage')
          }
        }
      })
    },
    loginWithotp () {
      // console.log('login with otp')
      this.isLoading = true
      var source = {
        type_otp: this.type_otp,
        phone: this.phone,
        otp: this.otpCode,
        mobile_ref_id: this.mobile_ref_id
      }
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/login_and_regis', source).then((response) => {
        this.status = response.data['status']
        // console.log(response.data)
        if (this.status === 'success') {
          localStorage.setItem('status_login', 'T')
          localStorage.setItem('profilepicture', response.data['account']['profile']['profilepicture'])
          localStorage.setItem('tokenservice', Encode.encodeToken(response.data['account']['profile']['tokenservice']))
          localStorage.setItem('tokenuser', Encode.encodeToken(response.data['account']['profile']['tokenuser']))
          localStorage.setItem('name', response.data['account']['profile']['name'])
          localStorage.setItem('phone', response.data['account']['profile']['phone'])
          localStorage.setItem('email', response.data['account']['profile']['email'])
          localStorage.setItem('status', response.data['account']['profile']['status'])
          this.isLoading = false
          this.getlistbot(response.data['account']['profile']['tokenuser'])
        } else {
          localStorage.setItem('status_login', 'F')
          this.isLoading = false
          this.$swal(
            'ขออภัย!',
            'กรอกรหัส OTP ไม่ถูกต้อง',
            'error'
          )
        }
      }, (error) => {
        console.log(error)
        this.$swal({ title: 'ระบบ login ขัดข้อง', text: 'กรุณาลองใหม่อีกครั้ง', type: 'error' })
        this.isLoading = false
        // this.status = 'fail'
        // this.failmessage = 'ไม่สามารถเชื่อมต่อกับเซิฟเวอร์ได้ กรุณาลองใหม่ในภายหลัง.'
      })
    }
  }
}
</script>
<style scoped>
.btnloginBackStep {
  color: #044766 !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: rgb(255 255 255) !important;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
a:link {
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

/* .text-field {
  border-radius: 100px;
} */

/* >>>.v-text-field--outline > .v-input__control > .v-input__slot {
  border: 1px solid #607d8b !important;
  border-radius: 50px !important;
  background: white !important;
} */
>>>.v-messages__message {
  padding-top: 5px;
  padding-bottom: 5px;
  color: rgb(255, 94, 116);
  text-shadow: -0.5px 0 gray, 0 0.3px rgb(255, 94, 116), 0.3px 0 red, 0 -0.2px gray;
}

>>>.v-btn.v-btn--outline {
  background: white !important;
}

.bg {
  background-image: url(../assets/onechat_official.jpeg);
  background-size: cover;
}

.btnloginwebOneid {
  color: white !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: rgba(4, 70, 102, 0.85) !important;
  /* background-color: #2562af !important; */
  /*border-radius: 10px;*/
  border: 2px solid white;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}
.btnloginwebOneid_white {
  color: rgba(4, 70, 102, 0.85)  !important;
  margin-top: 1vh !important;
  width: 80%;
  background-color: white !important;
  /*border-radius: 10px;*/
  border: 2px solid rgba(4, 70, 102, 0.85) ;
  border-radius: 50px;
  font-family: 'CS ChatThaiUI' !important;
}

.textor {
  color: white;
}

.textor:after,
.textor:before {
  content: "\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0\00a0";
  text-decoration: line-through;
  color: white;
}
>>>.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    border-radius: 2px;
    background: #fff;
    border-radius: 50px;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: #f5f5f5 !important;
}

</style>
